import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  AfterViewInit,
} from '@angular/core';
import { AdminService } from 'src/app/services/admin/admin.service';
import { LanguagesService } from 'src/app/services/languages/languages.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.css'],
})
export class LanguageSelectorComponent implements AfterViewInit {
  @Input() appId = 0;
  @Output() languageChanged = new EventEmitter<string>();
  @Input() showName = true;
  @Input() style = true;

  selectedLanguage: string = '';
  availableLanguages: any[] = [];
  load = false;
  error = false;

  private modalService: NgbModal;
  modalRef: NgbModalRef | null = null;

  constructor(
    private LanguagesService: LanguagesService,
    private cd: ChangeDetectorRef,
    private adminService: AdminService,
    modalService: NgbModal
  ) {
    this.modalService = modalService;
  }

  ngOnInit(): void {
    this.getLanguages();
    this.LanguagesService.productCategoryLanguage$.subscribe((lang) => {
      this.selectedLanguage = lang;
    });
  }

  open(content: TemplateRef<any>) {
    this.modalRef = this.modalService.open(content, {
      backdropClass: 'light-blue-backdrop',
      size: 'sm',
      scrollable: true,
    });
  }

  ngAfterViewInit(): void {
    // სხვა ოპერაციები საჭიროების შემთხვევაში
  }

  getLanguages(): void {
    this.load = true;
    this.LanguagesService.getUserLanguages(
      this.adminService.user.id.toString(),
      this.appId.toString()
    ).subscribe(
      (res: any) => {
        this.load = false;
        this.availableLanguages = res.languages;
      },
      () => {
        this.load = false;
        this.error = true;
      }
    );
  }

  selLang(languageCode: string): void {
    this.selectedLanguage = languageCode;
    this.LanguagesService.setProductCategoryLanguageSource(languageCode);
    this.languageChanged.emit(this.selectedLanguage);
    this.modalRef?.close();
  }

  getLanguageName(code: string): any {
    const lang = this.availableLanguages.find((l) => l.code === code);
    return lang || { name: 'იძებნება ენა', img: 'default-lang-img.png' };
  }
}